import React from "react";
import Svg, { Path } from "react-native-svg";

const NewMessageIcon = ({ width, height, color }) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      preserveAspectRatio="xMidYMin meet"
    >
      <Path
        d="M16.4286 9.98304C16.0341 9.98304 15.7143 10.2974 15.7143 10.6852V17.707C15.7143 18.0948 15.3945 18.4092 15 18.4092H2.14286C1.74836 18.4092 1.42856 18.0948 1.42856 17.707V3.66342C1.42856 3.27561 1.74836 2.96123 2.14286 2.96123H10.7143C11.1088 2.96123 11.4286 2.64685 11.4286 2.25904C11.4286 1.87122 11.1088 1.55688 10.7143 1.55688H2.14286C0.95939 1.55688 0 2.50001 0 3.66342V17.707C0 18.8704 0.95939 19.8135 2.14286 19.8135H15C16.1835 19.8135 17.1429 18.8704 17.1429 17.707V10.6852C17.1429 10.2974 16.8231 9.98304 16.4286 9.98304Z"
        fill={color}
      />
      <Path
        d="M19.1997 0.940001C18.6868 0.435748 17.9912 0.152517 17.2658 0.152599C16.5401 0.150542 15.8437 0.434266 15.3323 0.940453L5.92364 10.1888C5.84558 10.2661 5.7867 10.3601 5.7515 10.4634L4.32294 14.6765C4.19826 15.0444 4.40062 15.442 4.7749 15.5645C4.84752 15.5883 4.92357 15.6005 5.00007 15.6005C5.07675 15.6004 5.15296 15.5883 5.22578 15.5647L9.51151 14.1604C9.61677 14.1258 9.7124 14.0677 9.79079 13.9905L19.1994 4.74136C20.2673 3.69171 20.2674 1.98977 19.1997 0.940001Z"
        fill={color}
      />
    </Svg>
  );
};

NewMessageIcon.defaultProps = {
  width: 20,
  height: 20,
  color: "#16193F",
};

export default NewMessageIcon;
